module.exports = __webpack_public_path__ + "img/火龙果10.c8844317.png";